import { InjectionToken } from '@angular/core';

export interface AppConfig {
  name: string;
  apiHost: string;
  production: boolean;
}

export const APP_ENV_CONFIG = new InjectionToken<AppConfig>('Application Environment Config');

export const getEnvironment = (): AppConfig => {
  const host = window.location.host;

  if (host.includes('.sandbox.rocketkor')) {
    return { name: 'sandbox', production: true, apiHost: 'https://api.sandbox.rocketkor.net' };
  }
  if (host.includes('.stg.')) {
    return { name: 'staging', production: false, apiHost: 'https://api.stg.rocketkor-nonprod.net' };
  }
  if (host.includes('.qa.')) {
    return { name: 'qa', production: false, apiHost: 'https://api.qa.rocketkor-nonprod.net' };
  }
  if (host.includes('.dev.') || host.includes('.demo.')) {
    return { name: 'develop', production: false, apiHost: 'https://api.dev.rocketkor-nonprod.net' };
  }
  if (host.endsWith('rocketkor.net') || host.endsWith('rocketkor.com')) {
    return { name: 'production', production: true, apiHost: 'https://api.rocketkor.net' };
  }
  // default: local dev falls back to QA
  return { name: 'qa', production: false, apiHost: 'https://api.qa.rocketkor-nonprod.net' };
};
